export default __webpack_public_path__ + "static/media/download_playstore_btn-black.656314eb.svg";